import { render, staticRenderFns } from "./Forums.vue?vue&type=template&id=57c0f89b&scoped=true"
import script from "./Forums.vue?vue&type=script&lang=js"
export * from "./Forums.vue?vue&type=script&lang=js"
import style0 from "./Forums.vue?vue&type=style&index=0&id=57c0f89b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0f89b",
  null
  
)

export default component.exports